import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import NavbarVenditore, { infoUtente, loadNav } from "./Navbar";
import Table from "../../components/Table";
import PopUp from "../../components/PopUp";
import Checkbox from "../../components/Checkbox";
import * as XLSX from 'xlsx';
import Loader from '../../components/Loader.jsx';
import Alert from "../../components/Alert";
import Button from "../../components/Button.jsx";
import { useDeviceLayout } from "../../components/DeviceLayoutProvider";
import { Upload, Trash2, Info } from "lucide-react";

let piani = [];

const RowPC = ({ data, onCheckboxChange, setAlertInfo, setShowAlert }) => {
    const [isInfoDominioVisible, setIsInfoDominioVisible] = useState(false);
    const [infoDominio, setInfoDominio] = useState({});

    useEffect(() => {
        const loadInfoDominio = async () => {
            try {
                const r = await fetch('/getDominio', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: data.value.CodiceDominio })
                });
                const rd = await r.json();
                if (r.status === 500) {
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false); setIsInfoDominioVisible(false) }, needConfirm: false });
                    setShowAlert(true);
                }
                else {
                    setInfoDominio(rd[0]);
                }
            } catch (error) {
                console.error(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento delle informazioni del dominio.", onClose: () => { setShowAlert(false); setIsInfoDominioVisible(false) }, needConfirm: false });
                setShowAlert(true);
            }
        };
        if (isInfoDominioVisible) {
            loadInfoDominio();
        }
    }, [isInfoDominioVisible]);

    return (
        <div className="flex flex-row">
            <div onClick={(e) => e.stopPropagation()} className="flex items-center justify-center">
                <Checkbox
                    checked={data.checked}
                    onChange={() => onCheckboxChange(data.value.ID)}
                    size={18}
                />
            </div>
            <div className="grid grid-cols-6 py-4 border-b-2 border-gray-300 dark:border-neutral-700 w-full">
                <div className="flex items-center pl-2 ">
                    {data.value.CodiceAttivazione}
                </div>
                <div className="flex items-center pl-2 ">
                    {piani.find((d) => d.ID === data.value.IDPiano)?.Nome}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.ValiditaMesi}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.DataCreazione}
                </div>
                <div className="flex items-center pl-2 ">
                    {data.value.DataAttivazione}
                </div>
                <div
                    className={`flex items-center pl-2 ${data.value.CodiceDominio && ("text-blue-600 underline font-semibold hover:cursor-pointer no-row-action")}`}
                    onClick={(e) => {
                        if (!data.value.CodiceDominio) return;
                        setIsInfoDominioVisible(true);
                        e.stopPropagation();
                    }}
                >
                    {data.value.CodiceDominio}
                </div>
            </div>
            <PopUp title={"Informazioni Dominio"}
                isVisible={isInfoDominioVisible}
                setIsVisible={setIsInfoDominioVisible}
                needConfirm={false}

            >
                <div className="flex flex-col items-center">
                    <div className="w-[80%] md:w-[70%] mt-3">
                        <p className="flex justify-between">
                            Codice/P.iva :
                            <span className="font-semibold">{infoDominio["CodiceDominio"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Ragione Sociale :
                            <span className="font-semibold">{infoDominio["RagioneSociale"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Indirizzo :
                            <span className="font-semibold">{infoDominio["Indirizzo"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Città :
                            <span className="font-semibold">{infoDominio["Citta"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            CAP :
                            <span className="font-semibold">{infoDominio["Cap"]}</span>
                        </p>
                        <p className="flex justify-between mt-1">
                            Provincia :
                            <span className="font-semibold">{infoDominio["Provincia"]}</span>
                        </p>
                    </div>
                </div>
            </PopUp>
        </div>
    );
};

const RowMobile = ({ data, headers, keyForPreview }) => {
    return (
        <>
            {
                headers.map(header => (
                    !keyForPreview.includes(header.key) && (
                        <div key={`mobile-detail-${header.key}`} className="mb-2">
                            <span className="font-medium text-sm text-gray-500 dark:text-gray-400">
                                {header.label}:
                            </span>
                            <span className="ml-1 text-sm">
                                {header.key === 'IDPiano' ? ` ${piani.find((p) => p.ID === data.value[header.key])?.Nome}` : (data.value[header.key])}
                            </span>
                        </div>
                    )
                ))
            }
        </>
    );
}

const Dash = () => {
    const { isLittle } = useDeviceLayout();
    const headers = [
        { label: 'Codice', key: 'CodiceAttivazione' },
        { label: 'Piano', key: 'IDPiano' },
        { label: 'Validità (mesi)', key: 'ValiditaMesi' },
        { label: 'Data creazione', key: 'DataCreazione' },
        { label: 'Data attivazione', key: 'DataAttivazione' },
        { label: 'Dominio', key: 'CodiceDominio' },
    ];
    const [dataTable, setDataTable] = useState([]);
    const [dataRow, setDataRow] = useState({});
    const [isRowInfoVisible, setIsRowInfoVisible] = useState(false);
    const [isInfoDominioVisible, setIsInfoDominioVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [infoDominio, setInfoDominio] = useState({});
    const navigate = useNavigate();
    const [showAlert, setShowAlert] = useState(false);
    const [alertInfo, setAlertInfo] = useState({ type: "info", text: "", onClose: () => setShowAlert(false), needConfirm: false, onConfirm: () => { } });

    useEffect(() => {
        const loadInfoDominio = async () => {
            try {
                const response = await fetch('/getDominio', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ CodiceDominio: dataRow.CodiceDominio })
                });
                const data = await response.json();
                if (response.status === 500) {
                    console.log(data.error);
                    setAlertInfo({ type: "error", text: data.error, onClose: () => { setShowAlert(false); setIsInfoDominioVisible(false) }, needConfirm: false });
                    setShowAlert(true);
                }
                else {
                    setInfoDominio(data[0]);
                }
            } catch (error) {
                console.error(error);
                setAlertInfo({ type: "error", text: "Errore nel caricamento delle informazioni del dominio.", onClose: () => { setShowAlert(false); setIsInfoDominioVisible(false) }, needConfirm: false });
                setShowAlert(true);
            }
        };
        if (isInfoDominioVisible) {
            loadInfoDominio();
        }
    }, [isInfoDominioVisible]);

    useEffect(() => {
        onload();
    }, []);

    const onload = async () => {
        setIsLoading(true);
        await loadNav();
        try {
            const r1 = await fetch('/getPiani', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            const rd1 = await r1.json();
            if (r1.status === 500) {
                console.log(rd1.error);
                setAlertInfo({ type: "error", text: rd1.error, onClose: () => { setShowAlert(false); navigate('/') }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                piani = rd1;
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento dei piani", onClose: () => { setShowAlert(false); navigate('/') }, needConfirm: false });
            setShowAlert(true);
        }
        try {
            const r2 = await fetch('/getLicenzeVenditore', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ Venditore: infoUtente.Nome }),
            });
            const rd2 = await r2.json();
            if (r2.status === 500) {
                console.log(rd2.error);
                setAlertInfo({ type: "error", text: rd2.error, onClose: () => { setShowAlert(false); navigate('/') }, needConfirm: false });
                setShowAlert(true);
            }
            else {
                setDataTable(rd2.map(item => ({ value: item, checked: false })));
            }
        } catch (error) {
            console.error(error);
            setAlertInfo({ type: "error", text: "Errore nel caricamento delle licenze", onClose: () => { setShowAlert(false); navigate('/') }, needConfirm: false });
            setShowAlert(true);
        }
        setIsLoading(false);
    };

    const handleExport = () => {
        const dataChecked = dataTable.filter((d) => d.checked);
        if (dataChecked.length === 0) return;

        const dataSheet = dataChecked.map(d => ({
            CodiceAttivazione: d.value["CodiceAttivazione"],
            Piano: piani.find((p) => p.ID === d.value["IDPiano"]).Nome,
            ValiditaMesi: d.value["ValiditaMesi"],
            DataCreazione: d.value["DataCreazione"],
            DataAttivazione: d.value["DataAttivazione"],
            Dominio: d.value["CodiceDominio"]
        }));
        const worksheet = XLSX.utils.json_to_sheet(dataSheet);
        const workbook = XLSX.utils.book_new();

        XLSX.utils.book_append_sheet(workbook, worksheet, "Foglio1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.download = "Export.xlsx";
        link.click();
        window.URL.revokeObjectURL(url);
    };

    const handleElimina = async () => {
        const pass = async () => {
            setIsLoading(true);
            try {
                const r = await fetch('/eliminaLicenza', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ ID: dataRow.ID })
                });

                if (r.status === 200) {
                    window.location.reload();
                }
                else {
                    const rd = await r.json();
                    console.log(rd.error);
                    setAlertInfo({ type: "error", text: rd.error, onClose: () => { setShowAlert(false) }, needConfirm: false });
                    setShowAlert(true);
                }
            } catch (error) {
                console.log(error);
                setAlertInfo({ type: "error", text: "Errore nell'eliminazione della licenza", onClose: () => { setShowAlert(false) }, needConfirm: false });
                setShowAlert(true);
            }
            setIsLoading(false);
        };
        setAlertInfo({ type: "warning", text: "Sei sicuro di voler eliminare questa licenza?", onClose: () => { setShowAlert(false) }, needConfirm: true, onConfirm: pass });
        setShowAlert(true);
    };

    return (
        <div className="h-[100svh]">
            <NavbarVenditore page={"DASH"} />
            {isLoading && <Loader />}
            {showAlert && <Alert type={alertInfo.type} text={alertInfo.text} onClose={alertInfo.onClose} needConfirm={alertInfo.needConfirm} onConfirm={alertInfo.onConfirm} />}
            <div className="h-[93%] overflow-y-auto px-4">
                <Table
                    headers={headers}
                    keyForPreview={["CodiceAttivazione", "CodiceDominio"]}
                    data={dataTable}
                    setData={setDataTable}
                    renderRowPC={({ rowData, handleRowCheckboxChange }) => <RowPC data={rowData} onCheckboxChange={handleRowCheckboxChange} setAlertInfo={setAlertInfo} setShowAlert={setShowAlert} />}
                    renderRowMobile={({ rowData, headers, keyForPreview }) => <RowMobile data={rowData} headers={headers} keyForPreview={keyForPreview} />}
                    itemsPC={9}
                    itemsMobile={7}
                    needResearch={true}
                    specialFilter={[
                        { key: 'IDPiano', values: piani.map(p => ({ value: p.ID, label: p.Nome })) }
                    ]}
                    clickableRow={true}
                    actionRow={(row, rowIndex) => { setIsRowInfoVisible(true); setDataRow(row.value); }}
                    classes="mt-2"
                    needCheckbox={true}
                    renderButtonForCheckbox={() =>
                        <Button
                            type="hollow"
                            onClick={handleExport}
                        >
                            EXPORT <Upload size={20} className="inline-block ml-1" />
                        </Button>
                    }
                    needArchive={true}
                    archiveKey="Obsoleta"
                    archiveValue={true}
                />
                <PopUp title={""}
                    isVisible={isRowInfoVisible}
                    setIsVisible={setIsRowInfoVisible}
                    needConfirm={false}
                >
                    <>
                        {
                            isLittle ? (
                                <>
                                    <div className="grid grid-cols-2 mt-2">
                                        <Button
                                            type="hollow"
                                            onClick={handleElimina}
                                        >
                                            ELIMINA<Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                        </Button>
                                        <Button type="hollow" onClick={() => setIsInfoDominioVisible(true)}>
                                            INFO DOMINIO <Info size={16} strokeWidth={2} className="inline-block ml-1" />
                                        </Button>
                                    </div>
                                    <PopUp title={"Informazioni Dominio"}
                                        isVisible={isInfoDominioVisible}
                                        setIsVisible={setIsInfoDominioVisible}
                                        needConfirm={false}
                                    >
                                        <div className="flex flex-col items-center">
                                            <div className="w-[80%] md:w-[70%] mt-3">
                                                <p className="flex justify-between">
                                                    Codice/P.iva :
                                                    <span className="font-semibold">{infoDominio["CodiceDominio"]}</span>
                                                </p>
                                                <p className="flex justify-between mt-1">
                                                    Ragione Sociale :
                                                    <span className="font-semibold">{infoDominio["RagioneSociale"]}</span>
                                                </p>
                                                <p className="flex justify-between mt-1">
                                                    Indirizzo :
                                                    <span className="font-semibold">{infoDominio["Indirizzo"]}</span>
                                                </p>
                                                <p className="flex justify-between mt-1">
                                                    Città :
                                                    <span className="font-semibold">{infoDominio["Citta"]}</span>
                                                </p>
                                                <p className="flex justify-between mt-1">
                                                    CAP :
                                                    <span className="font-semibold">{infoDominio["Cap"]}</span>
                                                </p>
                                                <p className="flex justify-between mt-1">
                                                    Provincia :
                                                    <span className="font-semibold">{infoDominio["Provincia"]}</span>
                                                </p>
                                            </div>
                                        </div>
                                    </PopUp>
                                </>
                            ) : (
                                <div className="flex justify-center items-center">
                                    <Button type="hollow" onClick={handleElimina}>
                                        ELIMINA<Trash2 size={16} strokeWidth={2} className="inline-block ml-1" />
                                    </Button>
                                </div>
                            )
                        }
                    </>

                </PopUp >
            </div >
        </div >
    )
};

export default Dash;